import React, { Component } from 'react';

import Jumbo from '../components/Jumbotron';
import Cities from '../components/Cities';

class FrontPage extends Component {

  render(){
    const { cities } = this.props;
    return (
      <div>
        <Jumbo />
        <Cities data={ cities } />
      </div>
    )
  }
}

export default FrontPage;
